import { render, staticRenderFns } from "./CustomLoader.vue?vue&type=template&id=02b98e9e&scoped=true"
var script = {}
import style0 from "./CustomLoader.vue?vue&type=style&index=0&id=02b98e9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b98e9e",
  null
  
)

export default component.exports